import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-view-reason',
  templateUrl: './view-reason.component.html',
  styleUrls: ['./view-reason.component.css'],
})
export class ViewReasonComponent implements OnInit {
  datas;
  constructor(
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ViewReasonComponent>
  ) {
    this.datas = data;
  }

  ngOnInit(): void {}
  // Cancel
  cancelReason() {
    this.dialogRef.close();
  }
}
